// direct manipulation
import { currMenu, menuConfig, directContext, systemLog, callQueue, unlockedSpecs, currentSpec, dataInfo } from "./storage.js";
import { queryAxisGridGroups, queryAxisGraphcialElements } from "./component/axis.js";
import { get } from "svelte/store";
import { getAugmentation } from "./exploration/augment.js";

export function prepare(s) {
  Array.from(document.querySelectorAll(s + " path.background")).forEach(d => { d.remove(); });
}

export function clearHighlight() {
  let old_selected = document.querySelectorAll(".dupo-g-found");
  old_selected.forEach(d => { d.classList.remove("dupo-g-found") });
  let specific_selected = document.querySelectorAll(".dupo-g-found-specific");
  specific_selected.forEach(d => { d.classList.remove("dupo-g-found-specific"); });
}

function isView(dom) {
  return dom.tagName.toLowerCase() === "svg" && dom.classList.contains("marks");
}

function matchByAttribute(dom, attr) {
  if (attr) {
    for (const key in attr) {
      if (key === "class") {
        if (attr[key].constructor.name === "String" && !dom.classList.contains(attr[key])) return false;
        else if (attr[key].constructor.name === "Array" && !attr[key].every(n => dom.classList.contains(n))) return false;
      } else if (key === "tag") {
        if (dom.tagName.toLowerCase() !== attr[key]) return false;
      } else if (dom.getAttribute(key) !== attr[key]) {
        return false;
      }
    }
  }
  return true;
}

function recursiveSearch(dom, attr) {
  if (dom && isView(dom)) return null;
  else {
    if (matchByAttribute(dom, attr)) return dom;
    else if (dom.parentElement) return recursiveSearch(dom.parentElement, attr);
    else return null;
  }
}

function getViewDom(dom) {
  if (dom && matchByAttribute(dom, { class: "vega-embed", "data-role": "fronto-view" })) return dom;
  else if (dom && dom.parentElement) return getViewDom(dom.parentElement);
  else return null;
}

const vegaDataPattern = /^([^\:\;]+\:\s[^\:\;]+(\;\s)?)+$/;
export function parseDatumObject(datumExpr) {
  if (datumExpr.match(vegaDataPattern));
  let datum = {};
  datumExpr.split(";").forEach((e) => {
    let f = e.trim().split(": ");
    datum[f[0]] =
      get(dataInfo).stats[f[0]]?.rawType === "Number"
        ? parseFloat(f[1].replace("−", "-"))
        : f[1];
  });
  return datum;
}
export function covertMarkConditionPredicateToObject(pred) {
  let obj = {};
  pred.replace(/^\(/, "").replace(/\)$/, "").split(" && ").forEach((cond) => {
    let s = cond.split(" == ");
    obj[s[0].replace(/^datum\./, "")] = JSON.parse(s[1]);
  });
  return obj;
}
export function covertMarkConditionObjectToPredicate(obj) {
  let predicate = Object.keys(obj).map((dkey) => { return `datum.${dkey} == ${JSON.stringify(obj[dkey])}` }).join(" && ");
  return `(${predicate})`
}
export function getDirectContext(event, viewSelector, specToMatch) {
  // returns a path to specification (path); a list of context menus for direct manipulation (cmd);
  // @event: event object from double-click event;
  let artboard_uid = get(currentSpec).uid;
  if (!get(unlockedSpecs).includes(artboard_uid)) return;
  // output
  let paths = [], cmd = [];
  // canceling
  clearHighlight();

  // todo: group-wise slection
  // Identify element => propagate selection to groupwise
  let target = event.target;
  console.log("selected", target);
  let markSpecific, markRole;
  if (target.tagName === "path" && target.getAttribute("aria-label")?.match(vegaDataPattern)) {
    markSpecific = target.getAttribute("aria-label");
    markSpecific = parseDatumObject(markSpecific);
    markRole = target.getAttribute("aria-roledescription");
    // line/area mark shouldn't involve position channel data;
    if (markRole === "line mark" || markRole === "area mark") {
      let xs = specToMatch.layout.column?.map((d) => { return d.field || d });
      let ys = specToMatch.layout.row?.map((d) => { return d.field || d });
      xs.forEach((f) => { delete markSpecific[f]; });
      ys.forEach((f) => { delete markSpecific[f]; });
      console.log(markSpecific);
    }
  }
  let stop_default = false;
  if (isView(target)) {
    paths.push("artboard");
    cmd.push({
      name: "Edit artboard",
      icon: "easel-fill",
      run: function () {
        goToMenu({ first: "artboard", subMenu: "editArtboard" });
        systemLog.update(log => { log.log({ message: "(DM) Edit artboard", artboard_uid }); return log; });
      }
    });
    target.classList.add('dupo-g-found');
  } else {
    let searched;
    // legend
    if ((searched = recursiveSearch(target, { "data-role": "legend-replacement" }), searched)) {
      // className: F_layer_0__legend_0_labeled_fill
      let layerIndex = parseInt(searched.getAttribute("data-layer"));
      let channel = searched.getAttribute("data-channel");
      paths.push("layer", layerIndex, "legend", channel);
      cmd.push({
        name: "Edit legend",
        icon: "moisture",
        run: function () {
          goToMenu({ first: "legend", subMenu: "edit", channel, layerIndex });
          systemLog.update(log => { log.log({ message: "(DM) Edit legend", artboard_uid }); return log; });
        }
      })
      searched.classList.add('dupo-g-found');
    }
    // axis => axis design, RC layout
    else if ((searched = recursiveSearch(target, { "tag": "replacement", "data-role": "text-replacement" }), searched)) {
      if (searched.className.includes("fronto-label-axis-")) {
        // className: fronto-label-axis-y F_layer_0__axisLabel_2_cost
        let structure = searched.classList[0].split("-");
        let token = searched.classList[1].split("__");
        let subrole = structure[3];
        let layerIndex = parseInt(token[0].split("_")[2]);
        let [_, textIndex, field] = token[1].split("_");
        // axis
        paths.push("layer", layerIndex, "axis", structure[3]);
        cmd.push({
          name: "Edit axis",
          icon: "rulers",
          run: function () {
            goToMenu({ first: "axis", subMenu: "edit", layerIndex, textIndex, field });
            systemLog.update(log => { log.log({ message: "(DM) Edit axis", artboard_uid }); return log; });
          }
        });
        cmd.push({
          name: "Edit layout",
          icon: "grid-fill",
          run: function () {
            goToMenu({ first: "layout" });
            systemLog.update(log => { log.log({ message: "(DM) Edit RC", artboard_uid }); return log; });
          }
        });

        // group highlight
        // labels
        let labelGroupCN = "." + searched.classList[0] + "." + searched.classList[1]
        let labelGroup = searched.parentElement.querySelectorAll(labelGroupCN);
        labelGroup?.forEach(e => e.classList.add('dupo-g-found'));

        // axis domain & ticks;
        let view = getViewDom(searched);
        if (view) {
          let axisGridGroups = queryAxisGridGroups(view, subrole);
          axisGridGroups?.forEach((grid) => {
            Array.from(grid.children).forEach((g) =>
              g?.classList?.add("dupo-g-found")
            );
          });
          let axisGraphicalGroups = queryAxisGraphcialElements(
            view, subrole, false
          );
          axisGraphicalGroups.forEach((group) => {
            group.forEach((e) => e?.classList?.add("dupo-g-found"));
          });
        }
      } else if (searched.className.includes("fronto-label-")) {
        let token = searched.classList[1].split("__");
        let layerIndex = parseInt(token[0].split("_")[2]);
        let _, textIndex, field;
        if (token[1]) {
          [_, textIndex, field] = token[1]?.split("_");
        }
        // mark labels
        let label = specToMatch?.layer?.[layerIndex]?.text?.filter(t => t.type === "on-mark" && (t.field === field || t.aggregate === field))?.[0];
        if (label) {
          paths.push("layer", layerIndex, "mark.label", textIndex);
          cmd.push({
            name: "Edit mark labels (" + (label.field || label.aggregate) + ")",
            icon: "tags",
            run: function () {
              goToMenu({ first: "annotation", subMenu: "mark-label", layerIndex, textIndex, field: (label.field || label.aggregate) });
              systemLog.update(log => { log.log({ message: "(DM) Edit mark labels", artboard_uid }); return log; });
            }
          });

          // group highlight
          // labels
          let labelGroupCN = "." + searched.classList[0] + "." + searched.classList[1]
          let labelGroup = searched.parentElement.querySelectorAll(labelGroupCN);
          labelGroup?.forEach(e => e.classList.add('dupo-g-found'));
        } else if (token[0].startsWith("F_multiples_headerLabel")) {
          paths.push("layout");
          cmd.push({
            name: "Edit multiples layout and labels",
            icon: "grid",
            run: function () {
              goToMenu({ first: "layout" });
              systemLog.update(log => { log.log({ message: "(DM) Edit multiples layout and labels", artboard_uid }); return log; });
            }
          })
        }

      }
    }
    // mark => mark editing, label editing, / (todo) projection if geoshape
    else if ((searched = recursiveSearch(target, { "tag": "path", "role": "graphics-symbol" }), searched)) {
      let parent = searched.parentElement;
      let token = parent.classList[2].split("__");
      let layerIndex = parseInt(token[0].split("_")[2])
      // paths
      paths.push(...["layer", layerIndex, "mark"]);
      // commands
      cmd.push({
        name: "Edit mark and encodings",
        icon: "circle-square",
        run: function () {
          goToMenu({ first: "mark", layerIndex });
          systemLog.update(log => { log.log({ message: "(DM) Edit mark", artboard_uid }); return log; });
        }
      });
      let markLabels = specToMatch?.layer?.[layerIndex]?.text?.filter(t => t.type === "on-mark");
      markLabels?.forEach((label, textIndex) => cmd.push({
        name: "Edit mark labels (" + (label.field || label.aggregate) + ")",
        icon: "tags",
        run: function () {
          goToMenu({ first: "annotation", subMenu: "mark-label", layerIndex, textIndex, field: (label.field || label.aggregate) });
          systemLog.update(log => { log.log({ message: "(DM) Edit mark labels from mark", artboard_uid }); return log; });
        }
      }));
      if (markSpecific && get(currMenu) === "mark_individual") {
        goToMenu({ first: "mark_individual", layerIndex, datum: markSpecific, mark: markRole });
        systemLog.update(log => { log.log({ message: "(DM) Change idividual mark properties", artboard_uid }); return log; })
        stop_default = true;
      } else if (markSpecific) {
        cmd.push({
          name: "Edit the selected mark",
          icon: "circle-square",
          run: function () {
            goToMenu({ first: "mark_individual", layerIndex, datum: markSpecific, mark: markRole });
            systemLog.update(log => { log.log({ message: "(DM) Change idividual mark properties", artboard_uid }); return log; })
          }
        });
        target.classList.add("dupo-g-found-specific");
      }
      // highlight
      parent.childNodes.forEach(d => { d.classList.add("dupo-g-found") });
    }
    // geoshape
    else if ((searched = recursiveSearch(target, { "tag": "g", "class": "mark-shape", "role": "graphics-symbol" }), searched)) {
      if (Array.from(searched.classList).some(d => d.startsWith("F_geoLayer_"))) {
        paths.push("projection");
        // projection
        cmd.push({
          name: "Edit projection",
          icon: "map-fill",
          run: function () {
            goToMenu({ first: "projection" });
            systemLog.update(log => { log.log({ message: "(DM) Edit projection", artboard_uid }); return log; });
          }
        });
        // layout
        cmd.push({
          name: "Edit layout",
          icon: "grid-fill",
          run: function () {
            goToMenu({ first: "layout" });
            systemLog.update(log => { log.log({ message: "(DM) Edit projection layout", artboard_uid }); return log; });
          }
        });
        searched.classList.add("dupo-g-found");
      }
    }
    // annotations
    else if ((searched = recursiveSearch(target, { "tag": "annotation" }), searched)) {
      if (searched.className.startsWith("F_layer_")) {
        // mark label => label design
        let structure = searched.className.split("__");
        let layerIndex = parseInt(structure[0].split("_")[2]);
        paths.push("layer", layerIndex);
        let token = structure[1].split("_");
        let field = token[2];
        let textIndex = token[1];
        // let textIndex = specToMatch?.layer?.[layerIndex]?.text
        // ?.filter(t => t.type === "on-mark")
        // ?.map((t, i) => (t.field === field || (t.field === undefined && t.aggregate === field) ? i : undefined))
        // ?.filter(d => d !== undefined)[0];
        let textItem = specToMatch?.layer?.[layerIndex]?.text
          ?.filter(t => t.type === "on-mark")[textIndex];
        let textName = textItem.name;
        paths.push("text", textIndex);
        cmd.push({
          name: "Edit mark labels (" + field + ")",
          icon: "tags",
          run: function () {
            goToMenu({ first: "annotation", subMenu: "mark-label", layerIndex, textIndex, field });
            systemLog.update(log => { log.log({ message: "(DM) Edit mark labels", artboard_uid }); return log; });
          }
        })
        // highlighting
        let view = getViewDom(searched);
        if (view) {
          let labelGroup = view.querySelectorAll("annotation." + Array.from(searched.classList).join("."));
          labelGroup.forEach(t => t.classList.add("dupo-g-found"));
        }
        // drag
        let ruleScheme = {
          category: "direct",
          description: "Reposition mark labels",
          specifier: { role: "mark.label", field },
          action: "reposition",
          option: {}
        };
        let hasCallout = specToMatch?.layer?.[layerIndex]?.text[textIndex].tick;
        if (textName) ruleScheme.specifier.id = textName;
        makeDraggable(searched, ruleScheme, true, hasCallout);
      } else if (searched.className.startsWith("F_annotation_")) {
        // annotation => anno design
        let annoName = searched.getAttribute("data-name");
        let annoIndex = specToMatch?.annotation?.items
          ?.map((d, i) => (d.name === annoName ? i : undefined))
          ?.filter(d => d !== undefined)[0];
        let dataAnno = specToMatch?.annotation?.items[annoIndex].anchor !== undefined;
        if (annoIndex !== undefined) {
          paths.push("annotation", annoIndex);
          cmd.push({
            name: "Edit annotation (" + annoName + ")",
            icon: "tags",
            run: function () {
              goToMenu({ first: "annotation", subMenu: "annotation", annoIndex, annoName });
              systemLog.update(log => { log.log({ message: "(DM) Edit annotation", artboard_uid }); return log; });
            }
          });
          searched.classList.add("dupo-g-found");
          let ruleScheme = {
            category: "direct",
            description: "Reposition annotation (" + annoName + ")",
            specifier: { role: "annotation", id: annoName },
            action: "reposition",
            option: {}
          };
          let hasCallout = specToMatch?.annotation?.items[annoIndex].anchor?.callout === "yes";
          makeDraggable(searched, ruleScheme, dataAnno, hasCallout);
        }
      }
    }
    // external annotations
    else if ((searched = recursiveSearch(target, { "tag": "div", "data-role": "externalAnnotation" }), searched)) {
      console.log(searched)
      if (searched.className.startsWith("F_annotation_")) {
        // annotation => anno design
        let annoName = searched.getAttribute("data-name");
        let annoIndex = specToMatch?.annotation?.items
          ?.map((d, i) => (d.name === annoName ? i : undefined))
          ?.filter(d => d !== undefined)[0];
        if (annoIndex !== undefined) {
          paths.push("annotation", annoIndex);
          cmd.push({
            name: "Edit annotation (" + annoName + ")",
            icon: "tags",
            run: function () {
              goToMenu({ first: "annotation", subMenu: "annotation", annoIndex, annoName });
              systemLog.update(log => { log.log({ message: "(DM) Edit annotation", artboard_uid }); return log; });
            }
          });
          searched.classList.add("dupo-g-found");
        }
      }
    }
    // title => title design
    else if ((searched = recursiveSearch(target, { "data-role": "title" }), searched)) {
      let titleName = searched.getAttribute("name");
      let titleIndex = parseInt(searched.className.split("_")[2]);
      if (titleName && titleIndex !== undefined) {
        paths.push("title", titleIndex);
        cmd.push({
          name: "Edit title (" + titleName + ")",
          icon: "card-heading",
          run: function () {
            goToMenu({ first: "title", subMenu: "edit", titleIndex, titleName });
            systemLog.update(log => { log.log({ message: "(DM) Edit title", artboard_uid }); return log; });
          }
        });
        searched.classList.add("dupo-g-found");
      }
    }
  }
  if (!stop_default) {
    directContext.set({ paths, cmd });
  }
}

export function cancelDirectContext() {
  let old_selected = document.querySelectorAll(".dupo-g-found");
  old_selected.forEach(d => { d.classList.remove("dupo-g-found"); });
  let specific_selected = document.querySelectorAll(".dupo-g-found-specific");
  specific_selected.forEach(d => { d.classList.remove("dupo-g-found-specific"); });
  directContext.set(undefined);
}

export function getSelectedSpec(spec, paths) {
  let selected = [];
  paths?.forEach(path => {
    let parsedPath = path.split("/");
    let part = {};
    for (const p of parsedPath) {
      if (p === ".") part = spec;
      else if (p === "layout") part = spec.layout;
      else if (p === "layer") part = spec.layer;
      else if (p === "nondata") part = spec.nondata;
      else if (p === "annotation") part = spec.annotation;
      else if (p === "emphasis") part = spec.emphasis;
      else if (p === "title") part = spec.title;
      else if (p === "column") part = part?.column;
      else if (p === "row") part = part?.row;
      else if (p === "mark") part = part?.mark;
      else if (p === "axisText") part = part?.text?.filter(t => t.type === "on-axis");
      else if (p === "markText") part = part?.text?.filter(t => t.type === "on-mark");
      else if (p === "legend") part = part?.text?.filter(t => t.type === "legend");
      else if (p.match(/[0-9]+/gi) !== null) part = part?.[parseInt(p)];
      else if (p.match(/[0-9]+\+[^\+]+/gi) !== null) part = part?.[parseInt(p)];
      else if (p.match(/[0-9]+\+[^\+]+\+[^\+]+/gi) !== null) part = part?.[parseInt(p)];
      else console.log(p);
      console.log(part);
    }
    console.log(part);
    if (part) selected.push({ path, part });
  });
  return selected;
}

export function goToMenu(config) {
  if (config.first !== undefined && ["artboard", "legend", "axis", "title", "layout", "annotation", "mark", "mark_individual", "projection"].includes(config.first)) {
    currMenu.set(config.first);
    menuConfig.set(config);
    if (config?.finder) {
      setTimeout(config.finder, 500);
    }
  }
}
export function moveToSetting(config) {
  if (config.first !== undefined && ["preference", "exploration_history"].includes(config.first)) {
    currMenu.set(config.first);
    menuConfig.set(config);
  }
}
// dragging
function makeDraggable(dom, rule, isData, hasCallout) {
  // ref: https://www.w3schools.com/howto/howto_js_draggable.asp
  var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0, posd1, posd2, posd3 = 0, posd4 = 0;
  if (dom) {
    dom.onmousedown = initDragging;
  } else {
    dom.onmousedown = dragMouseDown;
  }

  function initDragging(e) {
    e = e || window.event;
    e.preventDefault();
    pos3 = e.clientX;
    pos4 = e.clientY;
    posd1 = dom.offsetLeft;
    posd2 = dom.offsetTop;
    posd3 = e.clientX;
    posd4 = e.clientY;
    document.onmouseup = finishDragging;
    document.onmousemove = onDragging;
  }

  function getMove(e) {
    let move = "f";
    if (e.shiftKey) {
      let d = Math.abs(posd3 - e.clientX) - Math.abs(posd4 - e.clientY)
      if (d > 0) { // horizontal move
        move = "h";
      } else if (d < 0) { // vertical move
        move = "v";
      } else { // diagonal move
        move = "d";
      }
    }
    return move;
  }
  function onDragging(e) {
    console.log(e)
    e = e || window.event;
    e.preventDefault();
    let move = getMove(e);
    if (move === "f") {
      pos1 = pos3 - e.clientX;
      pos3 = e.clientX;
      pos2 = pos4 - e.clientY;
      pos4 = e.clientY;
      dom.style.top = (dom.offsetTop - pos2) + "px";
      dom.style.left = (dom.offsetLeft - pos1) + "px";
    } else if (move === "h") {
      pos1 = pos3 - e.clientX;
      pos3 = e.clientX;
      dom.style.left = (dom.offsetLeft - pos1) + "px";
    } else if (move === "v") {
      pos2 = pos4 - e.clientY;
      pos4 = e.clientY;
      dom.style.top = (dom.offsetTop - pos2) + "px";
    } else if (move === "d") {
      pos1 = pos3 - e.clientX;
      pos3 = e.clientX;
      pos2 = pos4 - e.clientY;
      pos4 = e.clientY;
      dom.style.top = (dom.offsetTop - pos2) + "px";
      dom.style.left = (dom.offsetLeft - pos2) + "px";
    }
  }

  function finishDragging(e) {
    document.onmouseup = null;
    document.onmousemove = null;
    let unLocks = get(unlockedSpecs);
    let move = getMove(e);
    let currSpec = get(currentSpec);
    if (rule) {
      if (isData) {
        if (["h", "f"].includes(move)) {
          rule.option.dx = { by: parseInt(dom.style.left) - posd1 };
          if (hasCallout) {
            if (!rule.option.tick) rule.option.tick = { to: {} };
            rule.option.tick.to.dx = { by: parseInt(dom.style.left) - posd1 };
          }
        }
        if (["v", "f"].includes(move)) {
          rule.option.dy = { by: parseInt(dom.style.top) - posd2 };
          if (hasCallout) {
            if (!rule.option.tick) rule.option.tick = { to: {} };
            rule.option.tick.to.dy = { by: parseInt(dom.style.top) - posd2 };
          }
        }
        if (move === "d") {
          rule.option.dx = { by: parseInt(dom.style.left) - posd1 };
          rule.option.dy = { by: parseInt(dom.style.top) - posd2 };
          if (hasCallout) {
            rule.option.tick = {
              to: {
                dx: { by: parseInt(dom.style.left) - posd1 },
                dy: { by: parseInt(dom.style.top) - posd2 }
              }
            }
          }
        }
        // todo: change cornering
        if (rule.option?.tick) {
          rule.option.tick.cornering = "auto-flip";
        }
      } else {
        if (["h", "f"].includes(move)) rule.option.x = { by: parseInt(dom.style.left) - posd1 };
        if (["v", "f"].includes(move)) rule.option.y = { by: parseInt(dom.style.top) - posd2 };
        if (move === "d") {
          rule.option.x = { by: parseInt(dom.style.left) - posd1 };
          rule.option.y = { by: parseInt(dom.style.top) - posd2 };
        }
      }
      let anno = currSpec.fronto?.annotation?.items?.filter(d => d.name === rule.specifier.id)?.[0]
      callQueue.update((queue) => {
        queue.add([rule], unLocks).apply({
          afterUpdateAll: () => {
            if (isData) {
              if (rule.specifier.role === "annotation") {
                getAugmentation(
                  "annotation.position",
                  rule,
                  [anno.dx, anno.dy],
                  [rule.option.dx, rule.option.dy],
                  currSpec,
                  unLocks,
                  anno
                );
              }
            }
          },
        });
        return queue;
      });
    }
  }
}